import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Chip } from '@material-ui/core';

export interface Item {
  draggableId: string;
  label: string;
}

const useStyles = makeStyles({
  item: {
    backgroundColor: '#A3E0E9',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    margin: '5px',
  },
  draggingListItem: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
});

export type DraggableListItemProps = {
  item: Item;
  index: number;
};

const DraggableListItem = ({ item, index }: DraggableListItemProps) => {
  const classes = useStyles();
  return (
    <Draggable draggableId={item.draggableId} index={index}>
      {(provided, snapshot) => (
        <Chip
          key={`${item.draggableId}_${index}`}
          label={item.label}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={snapshot.isDragging ? classes.draggingListItem : classes.item}
        />
      )}
    </Draggable>
  );
};

export default DraggableListItem;
